import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { routePaths } from "../../../../common/infrastructure/routes/routePaths";
import { useAppContext } from "../../../../AppContext";
import { ILowStockProductModel } from "../models/inventoryOverviewModels";

export const useQuantityTab = () => {
  const { selectedStudioId } = useAppContext();
  const navigate = useNavigate();

  const queryKey = [endpointsMetadata.inventoryOverview.getProductsByQuantity, selectedStudioId];

  const { data: products = [], isLoading } = useApiQuery<ILowStockProductModel[]>({
    queryKey,
    endpoint: endpointsMetadata.inventoryOverview.getProductsByQuantity,
    enabled: selectedStudioId > 0,
    globalIsLoading: false,
  });

  const lowStockItems = useMemo(
    () => products.filter((p) => p.currentQuantity <= p.lowStockThreshold),
    [products],
  );

  const hasLowStockItems = lowStockItems.length > 0;

  const navigateToCreateTransfer = useCallback(() => {
    navigate(routePaths.inventoryTransfers, {
      state: { lowStockItems },
    });
  }, [navigate, lowStockItems]);

  return { products, isLoading, hasLowStockItems, navigateToCreateTransfer };
};
